window.addEventListener("DOMContentLoaded", () => {
  const pageOverlay = document.querySelector(".pageOverlay");
  const stickySearch = document.querySelector("#dT_top-sticky");
  const searchTriggers = document.querySelectorAll(
    ".site-header__search_icon.dT_TopStickySearchBtn"
  );
  const menuTriggers = document.querySelectorAll(".menu-trigger");

  document.body.style.visibility = "visible";

  searchTriggers.forEach((searchTrigger) => {
    searchTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      pageOverlay.classList.add("pageOverlay__visible");
      stickySearch.classList.add("sticky-search__open");
    });
  });
  document
    .querySelector(".dT_TopStickySearchCloseBtn")
    .addEventListener("click", () => {
      stickySearch.classList.remove("sticky-search__open");
      pageOverlay.classList.remove("pageOverlay__visible");
    });
  pageOverlay.addEventListener("click", () => {
    pageOverlay.classList.remove("pageOverlay__visible");
    stickySearch.classList.remove("sticky-search__open");
  });

  menuTriggers.forEach((menuTrigger) => {
    menuTrigger.addEventListener("click", () => {
      document.querySelector(".mobile-menu").classList.add("nav-is-visible");
      document
        .querySelector(".mobile-menu-overlay")
        .classList.add("is-visible");
    });
  });
});
